import LeadCaptureForm, {
  LeadCapturePopupFormProps,
  leadCapturePopupFormSchema,
  LeadCapturePopupFormValues,
} from './LeadCapturePopupForm'

export default LeadCaptureForm
export { leadCapturePopupFormSchema }
export type { LeadCapturePopupFormValues, LeadCapturePopupFormProps }
